// extracted by mini-css-extract-plugin
module.exports = {"content":"Rehabilitation_content__3MYvn","heading":"Rehabilitation_heading__18EWD","text":"Rehabilitation_text__334mi","logo":"Rehabilitation_logo__1Q0rC"};